/// <amd-module name="Search/Shared/Base/Stores/SortOptionsStore" />

import * as SearchShared from "Search/LegacyWebApi/Contracts/Search.SharedLegacy";
import { Store } from "VSS/Reflux/Store";
import { ISortOptionChangedPayload } from "Search/Shared/Base/ActionsHub";

export interface ISortOptionsStoreState {
    sortOption: SearchShared.EntitySortOption;
}

export class SortOptionsStore<TItem> extends Store {
    protected _state: ISortOptionsStoreState = {} as ISortOptionsStoreState;

    public get state(): ISortOptionsStoreState {
        return this._state;
    }

    public changeSortOption = (payload: ISortOptionChangedPayload<TItem>) => {
        const { sortOption } = payload;
        this._state.sortOption = sortOption;
        this.emitChanged();
    }
}